import React, { useState,useEffect,useRef } from 'react'
import { Card } from 'primereact/card';
import { Paginator } from 'primereact/paginator';
import { Toast } from 'primereact/toast';
import { useContext } from 'react';
import { Skeleton } from 'primereact/skeleton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button'; 
import { getAllManuals,deleteManual,createManual,editManual,getOneManual} from '../../api/axiosManuals';
import DataContext from '../../context/DataContext';
import { API_URL } from '../../config/constants';
import { AllToasts } from '../../components/Toasts/AllToasts';
import { useNavigate } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import DeleteDialog from '../../components/dialogs/DeleteDialog';
import { Dropdown } from 'primereact/dropdown';
import { FileUpload } from 'primereact/fileupload';
import { PrimeIcons } from 'primereact/api';
import SearchToolBar from '../../components/buttonActions/SearchToolBar';
import TableActions from '../../components/buttonActions/TableActions';



 



const ManualsSettings = () => {
  const { manuals, setManuals, setFetcherror } = useContext(DataContext);
  
  const manualTypes = [{ id: 0, name: "Kit" }, { id: 1, name: "Report" }, { id: 2, name: "User Manual" }];
  const fileBrowseOption1 = <span><i className="pi pi-upload" style={{ fontSize: '1rem' }}></i> &nbsp; Choose the File to Upload</span>
  const fileBrowseOption2 = (e) => { return <span className="danger"><i className="pi pi-paperclip" style={{ fontSize: '1rem' }}></i> &nbsp; {e.target.files[0]?.name}</span> }
  const fileBrowseOption3 = (uri) => { return <span className="danger"><i className="pi pi-paperclip" style={{ fontSize: '1rem' }}></i> &nbsp; {uri}</span> }
  
  const toast = useRef(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const navigate = useNavigate()

  const [addItemeDialogVisible, setAddItemDialogVisible] = useState(false);
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  
  const [selectedId, setSelectedId] = useState(); //Track Id for Deleting or Editing
  
  const [manual, setManual] = useState("");
  const [editedManual, setEditedManual] = useState("");
  const [selectedType, setSelectedType] = useState([]);
  const [editedSelectedType, setEditedSelectedType] = useState("");
  const [file, setFile] = useState(null);
  const [editedFile, setEditedFile] = useState(null);
  const [filebrowse, setFileBrowse] = useState(fileBrowseOption1);
  const [editedFileBrowse, setEditedFileBrowse] = useState(<></>);
  
  
  const [isLoading, setIsLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);


  useEffect(() => {
    getAllManuals(setManuals, setFetcherror, setIsLoading, setFirst, setRows,undefined,setTotalCount);
    
  }, []);  
    
  const onPageChange = (event) => {
    getAllManuals(setManuals, setFetcherror, setIsLoading, setFirst, setRows, event, setTotalCount);
  };
  
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setFileBrowse(fileBrowseOption2(e));
  };

  const handleEditedFileChange = (e) => {
    setEditedFile(e.target.files[0]);
    setEditedFileBrowse(fileBrowseOption2(e));
  };
  const limitOptions = [5, 10, 20, 30, 50];
  const skeletonitems = Array.from({ length: 5 }, (v, i) => i);

  const pagemainHeader = (
    <div className='text-center'> MANUALS</div>
  );
  


  
  const filteredManuals = manuals.filter((item) => item.name.toLowerCase().includes(globalFilter.toLowerCase()));
  // const filteredReversedTribes = filteredTribes.reverse();
  
  const handleAllToasts = (statusNum, msg) => {
    AllToasts(statusNum, msg, toast);
  };

  // Delete Dialogue
  const deletefunction = (pkid,setManuals,setFetcherror,handleAllToasts,setIsLoading,setFirst,setRows,event,setTotalCount) => {
    return () => {
      deleteManual(pkid, setManuals,setFetcherror,handleAllToasts,setIsLoading,setFirst,setRows,event,setTotalCount);
    };
  };
  const deletedialogHeader = "Confirm Delete";
  const deletedialogContents = (
      <p>Do you really want to delete this Manual?, Click "Yes" to Proceed or "No" to Cancel</p>
  );

  const getItemtoEdit = (pkid, items) => {
    const foundItem = items.find((item) => item.id === pkid);
    setEditedManual(foundItem?.name);
    setEditedFileBrowse(fileBrowseOption3(foundItem?.uri));
    setEditedSelectedType(manualTypes.find((type) => type.name === foundItem.type));
   
  };


  const toProper = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };



  return (
    <>
  
      <Card title="All Manuals" className='m-1'>
      <Toast ref={toast} /> 
          
            <SearchToolBar
                      setAddItemDialogVisible={setAddItemDialogVisible}
                      globalFilter={globalFilter}
                      setGlobalFilter={setGlobalFilter}
                      searchPlaceholder="Manuals"
                      createLabel="Manual"
              />

        
        {!isLoading &&
            <DataTable
              value={filteredManuals}
              showGridlines
              emptyMessage="No Manuals Found"
            >
              <Column header="S/N" body={(rowData) => manuals.indexOf(rowData) + 1+ first} sortable> </Column>
              <Column header="Name" body={(rowData) => rowData.name} sortable></Column>
              <Column header="Type" body={(rowData) => toProper(rowData.type)} sortable></Column>
              <Column header="Actions" body={(rowData) => (
                <div className='flex flex-row justify-content-cente'>
                  <Button
                    icon="pi pi-file-pdf"
                    outlined
                    severity="primary"
                    aria-label="view"
                    label='View'
                    onClick={() => { window.open(`${API_URL}/fsmanuals/${rowData.uri}`, '_blank'); }} 
                    className='px-3 py-1 text-xs mr-2'
                 />
                  <Button
                    icon="pi pi-pencil"
                    outlined
                    severity="success"
                    aria-label="Edit"
                    label='Edit'
                    className='px-3 py-1 text-xs mr-2'
                    onClick={() => {
                      getItemtoEdit(rowData.id, manuals); setSelectedId(rowData.id); setEditDialogVisible(true);}}           
                  />
                
                  <Button
                    icon="pi pi-trash"
                    outlined
                    severity="danger"
                    aria-label="Cancel"
                    label='Delete'
                    className='px-3 py-1 text-xs'
                    onClick={() => {setSelectedId(rowData.id);setDeleteDialogVisible(true);}}            
                  />
                </div>          
              )}>
              </Column>
            </DataTable>
          } 
          
          {isLoading && 
          
          <DataTable value={skeletonitems} className="p-datatable-striped">
          <Column field="S/N" header="S/N" style={{ width: '25%' }} body={<Skeleton />}></Column>
          <Column field="Name" header="Name" style={{ width: '25%' }} body={<Skeleton />}></Column>
          <Column field="Type" header="Type" style={{ width: '25%' }} body={<Skeleton />}></Column>
          <Column field="Actions" header="Actions" style={{ width: '25%' }} body={<Skeleton />}></Column>
          </DataTable>
          }

          {!isLoading &&
            <Paginator
              first={first}
              rows={rows}
              totalRecords={totalCount}
              rowsPerPageOptions={limitOptions}
              onPageChange={onPageChange}
            />
          }
          
          {addItemeDialogVisible &&
          
          <div className="card flex justify-content-center">
            <Dialog className='-mt-8' header="New Manual" visible={addItemeDialogVisible} style={{ width: '25vw' }} onHide={() => { setAddItemDialogVisible(false);setFileBrowse(fileBrowseOption1); }} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                createManual(
                  manual,
                  setManual,
                  selectedType,
                  setSelectedType,
                  file,
                  setFile,
                  setFetcherror,
                  handleAllToasts,
                  setManuals,
                  setIsLoading,
                  setFirst,
                  setRows,
                  undefined,
                  setTotalCount
                );
                setFileBrowse(fileBrowseOption1);
                if (manual) { setAddItemDialogVisible(false); }
              }}>
                  <label htmlFor="Type" className="block text-900 font-medium mb-2">Manual Type </label>
                  <Dropdown
                    value={selectedType}
                    onChange={(e) => {setSelectedType(e.value);}}
                    options={manualTypes} optionLabel="name"
                    placeholder="-- Select Type --"
                    showClear
                    className="w-full mb-4"
                 />
                
                  <label htmlFor="manual" className="block text-900 font-medium mb-2">Manual Name </label>
                  <InputText
                    className='w-full mb-4'
                    type="text"
                    placeholder="Enter Manual Name"
                    value={manual}
                    onChange={(e) => setManual(e.target.value)}
                />
                
                <label htmlFor="uri" className="block text-900 font-medium mb-4 uploadfile" >{ filebrowse}   </label>
                <input type="file" name="uri" id="uri" className="chooseManual"   accept="image/*,audio/*,.pdf,.doc,.docx"  onChange={handleFileChange} />
                  
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setAddItemDialogVisible(false); setManual(""); setFileBrowse(fileBrowseOption1); setSelectedType([]); }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }
        



        {
          editDialogVisible &&
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="Edit Tribe" visible={editDialogVisible} style={{ width: '25vw' }} onHide={() => setEditDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                  editManual(
                    selectedId,
                    editedManual,
                    setEditedManual,
                    editedSelectedType,
                    setEditedSelectedType,
                    editedFile,
                    setEditedFile,
                    setFetcherror,
                    handleAllToasts,
                    setManuals,
                    setIsLoading,
                    setFirst,
                    setRows,
                    undefined,
                    setTotalCount
                  );
                if (editedManual) { setEditDialogVisible(false); }
                }}>
                  
                  <label htmlFor="editedSelectedType" className="block text-900 font-medium mb-2">Manual Type </label>
                  <Dropdown
                    value={editedSelectedType}
                    onChange={(e) => {setEditedSelectedType(e.value);}}
                    options={manualTypes} optionLabel="name"
                    placeholder="-- Select Type --"
                    showClear
                    className="w-full mb-4"
                  />
                  
                  <InputText
                    className='w-full mb-4'
                    type="text"
                    // disabled
                    placeholder="Enter Manual Name"
                    value={editedManual}
                    onChange={(e) => setEditedManual(e.target.value)}
                  />
                  
                  <label htmlFor="uri" className="block text-900 font-medium mb-4 uploadfile" >{ editedFileBrowse}   </label>
                  <input type="file" name="uri" id="uri" className="chooseManual" accept="image/*,audio/*,.pdf,.doc,.docx" onChange={handleEditedFileChange} />
                  
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setEditDialogVisible(false);   }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }

        
        
        {
                deleteDialogVisible &&
                <DeleteDialog
                    dilogvisible={deleteDialogVisible}
                    setDilogvisibleVisible={setDeleteDialogVisible}
                    deletefucton={deletefunction(selectedId, setManuals,setFetcherror,handleAllToasts,setIsLoading,setFirst,setRows,undefined,setTotalCount)}
                    dialogHeader={deletedialogHeader}
                    dialogContents={ deletedialogContents}
                    
                 />
      } 
        </Card>
    </>
      
  )
}

export default ManualsSettings